import React, { useState, useEffect, useContext, useRef } from "react";
import Footer from "../../../components/dashboard/footer";
import { contentContext } from "../../../context/contentContext";
import SideMenu from "../../student/SideMenu";
import Loader from "../../../components/loader";
// import Sidebar from "../../../components/dashboard/sidebar";
import Header from "../../../components/dashboard/header";
import { useParams, useNavigate } from "react-router-dom";
import tmdbApi from "../../../api/tmdbApi";
import DataTable from 'react-data-table-component';
import Modal from 'react-bootstrap/Modal';




const CPCResInfo = () => {
    let { id } = useParams();
    const [cpcResult, setCPCResult] = useState([])
    const [cPCAnswers, setCPCAnswers] = useState([])
    const { searchedFlag, setSearchedFlag, isLoading, setIsLoading, processObject, sortTableAlpha, arrow, sortTableByDate, userData, companysearch, setCompanySearch, companyadvSearch, setCompanyAdvSearch, currentPage, setcurrentPage, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, setActiveMenuObj, GetTimeActivity } = useContext(contentContext)
    const [anncouncePopup, setAnnouncePopup] = useState(false);
    const navigate = useNavigate();
    const [cpcQtns, setCpcQtns] = useState([]);
    const getCaseInfo = async (caseid) => {
        const response = await tmdbApi.cpcCaseInfo(caseid);
        return response.result?.questionData
    }

    const fetchData = async (cases) => {
        if (cases?.length > 0) {
            let casid = cases.map(item => item.caseid)
            const tmpData = await getCaseInfo(casid);
            let caseData = cases.map((c) => {
                let caseDetails = tmpData.filter(t => t.caseid === c.caseid)

                if (caseDetails.length > 0) {
                    c['clinicalhistory'] = caseDetails[0]?.clinicalhistory || ''
                }
                return c;
            })
            // setCpcQtns(caseData);
            console.log("caseDatatatatatatatatatata", caseData)
        }
    };

    const onCancel = () => {
        localStorage.setItem("completedTab", "yes")
        navigate("/cpcmanagement");
    }
    useEffect(() => {
        getCpcInfoById()

    }, [])
    const getCpcInfoById = async () => {
        setIsLoading(true)
        let response = await tmdbApi.cpcviewResult(id);
        if (typeof response?.result === 'string') {
            alert("no active cpc")
            setIsLoading(false)
        }
        if (response?.result?.length > 0) {
            setCPCResult(response?.result)
            setIsLoading(false)
        }
        let cpcDetails = await tmdbApi.cpcInfoById(id)
        if (typeof cpcDetails?.result === 'string') {
            alert("no active cpc")
            setIsLoading(false)
        }
        if (cpcDetails?.result?.length > 0) {

            fetchData(cpcDetails?.result[0].cases)
            setIsLoading(false)
        }
    }

    const handleView = async (row) => {

        await getAnswers(row?.cpcid, row?.studentId)
        setAnnouncePopup(true)
    }

    const getAnswers = async (id, userId) => {

    let response = await tmdbApi.cpcParticipantAnswersInfoByUser(id, userId, { projection: "cpcanswers" });
        if (typeof response?.result === 'string') {
            alert("no active cpc")
        }
        if (response?.result?.length > 0) {
            setCPCAnswers(response?.result)
            setCpcQtns(response?.result?.[0]?.cases);
            console.log("participateddattatatatatatatatatatatata", response?.result?.[0]?.cases, response?.result)
        }
    }
    const cpccolumns = [

        {
            name: 'Participants',
            selector: row => row?.name,
            sortable: false,
        },
        {
            name: 'Email',
            selector: row => row?.emailid,
            sortable: false,
        },

        {
            name: 'Phone No',
            selector: row => row?.number,
            sortable: false,
        },
        //  {
        //     name: 'Registered Count',
        //     selector: row => row?.reservedCount,
        //     sortable: false,
        // },
        //  {
        //     name: 'Participated Count',
        //     selector: row => row?.participatedCount,
        //     sortable: false,
        // },
        {
            name: 'Score',

            cell: (props) =>
                <div className="d-flex">
                    {props?.score} / {props?.casesCount}
                </div>
        },
        {
            name: 'Percentile',
            cell: (props) =>

                <div className="d-flex">
                    {props?.percentileRank} / 100
                </div>

        },
        {
            name: 'Winner',
            cell: (props) =>

                props?.winner ? <div className="winner">
                    <span className="material-symbols-outlined icon">
                        trophy
                    </span>
                </div> : <></>

        },
        {
            name: 'Answers',
            cell: (props) => <div>
                <a onClick={() => handleView(props)} className='text-success view-button view-icon-info'><i
                    className="mdi mdi-eye font-size-16"></i>  </a>
            </div>
        }


    ];





    return (

        <div id="layout-wrapper">
            <Header />
          <SideMenu />

            <div className="main-content user-management completeCpc" id="main-content">
                <div className="page-content" id="page-content">
                    <div className="container-fluid" id="container-fluid">
                        <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                            <div className="col-lg-12">
                                <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                        <h4 className="mb-2 card-title" id="breadcrumb-title">

                                        </h4>

                                    </div>
                                    <div className="create-quiz-btn" onClick={() => onCancel()}>
                                        Back
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row table-data">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-body cpc-management">

                                        <div className="cpc-completed-view-page">
                                            {isLoading ? <Loader /> : cpcResult.length > 0 ? <DataTable
                                                columns={cpccolumns}
                                                data={cpcResult}
                                                pagination
                                                highlightOnHover
                                                striped
                                                selectableRows={false}
                                            /> : <div className="empty-state-body empty-record"  >
                                                <div className="empty-state__message">
                                                    <span className="material-icons">summarize</span>
                                                    <p className="form-check font-size-16"><div className="alert alert-warning mt-3">No  CPC is present. </div></p>
                                                </div>
                                            </div>
                                            }
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
                <Modal className="completedCpcTable" show={anncouncePopup} >

                    <div className="modal-body enquiry-form">
                        <div className="container">
                            <button className="close-btn" onClick={e => setAnnouncePopup(false)}><span className="material-icons">close</span></button>

                            <table className="table align-middle table-nowrap mb-0 case-answers-table" id="quiz-table-cpc" style={{ tableLayout: 'fixed', width: '100%' }}>
                                {/* <colgroup>
                                    <col style={{ width: '40%' }} />
                                    <col style={{ width: '40%' }} />
                                    <col style={{ width: '20%' }} />
                                </colgroup> */}
                                <tbody>
                                    {cpcQtns.length > 0 &&
                                        cpcQtns.map((ccp, qIndex) => (
                                            <React.Fragment key={qIndex}>
                                                <tr className="bg-light">
                                                    <td>
                                                        Case {qIndex + 1}

                                                    </td>
                                                    <td>Answer</td>

                                                    <td>Points</td>
                                                    <td>weightage</td>
                                                    <td>Score</td>

                                                </tr>
                                                {/* <tr className="case-table bg-light">
                                                    <td colSpan={3}>
                    
                                                        <div dangerouslySetInnerHTML={{ __html: ccp?.clinicalhistory }} />
                                                    </td>
                                                    <td>Answer</td>
                                                    <td>Score</td>
                                                </tr> */}
                                                {ccp?.answers?.map((ansItem, aIndex) => (
                                                    ansItem.hasOwnProperty("isCorrect") && (
                                                        <tr key={aIndex}>
                                                            <td></td>
                                                            <td>{ansItem?.answer}</td>
                                                            <td>{ansItem?.points}</td>
                                                            <td>{ansItem?.weightage}</td>

                                                            <td >{ansItem?.score || 0}</td>
                                                        </tr>
                                                    )
                                                ))}
                                            </React.Fragment>
                                        ))}
                                </tbody>
                            </table>

                        </div>
                    </div>

                </Modal>
            </div>

        </div>

    );
};

export default CPCResInfo;
